<template>
  <div>
    <div class="date_picker_wrap">
      <date-picker v-model="pickedMonth" type="month" custom="calendar" height="34" background-color="white"></date-picker>
    </div>
    <v-sheet height="450" class="px-5 py-10 calendar_wrap">
      <v-calendar
        ref="calendar"
        v-model="focus"
        :show-month-on-first="false"
        :start="startMonth"
        color="primary"
        type="month"
        :day-format="setDay"
        :events="calendarEvents"
        @click:more="clickDay"
        @change="getCalendarEvents"></v-calendar>
    </v-sheet>
  </div>
</template>

<script>
import DatePicker from '@/components/common/DatePicker';
export default {
  name: 'UserCalendar',
  components: {
    DatePicker,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    focus: '',
    pickedMonth: new Date().toISOString().substr(0, 7),
    startMonth: new Date().toISOString().substr(0, 10),
    calendarEvents: [],
  }),
  watch: {
    pickedMonth(val) {
      this.startMonth = new Date(val);
    },
  },
  methods: {
    clickDay({ date }) {
      this.$emit('clickDate', date);
    },
    setDay(payload) {
      let i = new Date(payload.date).getDate();
      return i;
    },
    getCalendarEvents({ start }) {
      const events = [];
      const yearMonth = start.date.substr(0, 7);
      const thisMonth = this.data.filter(obj => obj.day.substr(0, 7) === yearMonth);

      for (const obj of thisMonth) {
        if (obj.state) {
          const firstTimestamp = new Date(`${obj.day}T00:00:00`).getTime();
          events.push({
            name: 'dd',
            timed: true,
            start: firstTimestamp,
          });
        }
      }

      this.calendarEvents = events;
    },
  },
};
</script>

<style scoped></style>
